import { TransformType } from '../../constant';

/** 发票类型中文显示 */
const transformTypeString = (type: TransformType): string => {
    switch (type) {
        case TransformType.增值税专用发票:
            return '增值税专用发票';
        case TransformType.增值税电子专用发票:
            return '增值税电子专用发票';
        case TransformType.增值税普通发票INVOICE:
            return '增值税普通发票';
        case TransformType.增值税普通发票卷票:
            return '增值税普通发票(卷票)';
        case TransformType.增值税电子普通发票:
            return '增值税电子普通发票';
        case TransformType.增值税电子普通发票VAT:
            return '增值税电子普通发票';
        case TransformType.未知发票类型:
            return '未知发票类型';
        case TransformType.机动车销售统一发票:
            return '机动车销售统一发票';
        case TransformType.货运运输业增值税专用发票:
            return '货运运输业增值税专用发票';
        case TransformType.通行费发票:
            return '增值税电子普通发票';
        case TransformType.二手车销售统一发票:
            return '二手车销售统一发票';
        case TransformType.全电专票:
            return '全电发票(增值税专用发票)';
        case TransformType.全电普票:
            return '全电发票(普通发票)';
        default:
            return '增值税普通发票';
    }
};

export default transformTypeString;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/Language/transformTypeString/index.ts